import { http } from '@/utils/axios'

/**
 * @msg: 获取办学院校列表
 */
export function getLocationList(data) {
    return http({
        url: http.baseUrl('elAlbum/getLocationList'),
        method: 'get',
        params: http.params(data)
    })
}

/**
 * @msg: 获取开考专业列表
 */
export function getMajorList(data) {
    return http({
        url: http.baseUrl('elAlbum/getMajorList'),
        method: 'get',
        params: http.params(data)
    })
}

/**
 * @msg: 获取承诺书列表
 */
export function getUndertakingList(data) {
    return http({
        url: http.baseUrl('elAlbum/getUndertakingList'),
        method: 'get',
        params: http.params(data)
    })
}

/**
 * @msg: 获取机构列表
 */
export function getOrganLists() {
    return http({
        url: http.baseUrl('elSchool/getList'),
        method: 'post',
        params: http.params({})
    })
}

/**
 * @msg: 获取班主任列表
 */
export function getClassAdviserList(data) {
    return http({
        url: http.baseUrl('elAlbum/getClassAdviserList'),
        method: 'get',
        params: http.params(data)
    })
}

/**
 * @msg: 新增或编辑班级
 */
export function saveOrUpdate(data) {
    return http({
        url: http.baseUrl('elAlbum/saveOrUpdate'),
        method: 'post',
        data: data,
        params: http.params(data)
    })
}

/**
 * @msg: 获取合作院校
 */
 export function getPartnerSchool() {
    return http({
        url: http.baseUrl('elAlbum/getPartnerSchool'),
        method: 'get'
    })
}

/**
 * @msg: 获取合作机构
 */
 export function getPartnerInstitution() {
    return http({
        url: http.baseUrl('elAlbum/getPartnerInstitution'),
        method: 'get',
    })
}
